import React from 'react'
import styled from 'styled-components'

const IconDefinition = styled.i`
padding-right: 10px;
cursor: pointer;
`
IconDefinition.displayName = 'Icon'
export const Icon = IconDefinition

export const ChevronIcon = ({ direction }) => {
  return <Icon className={`fa fa-chevron-${direction}`} />
}

export const DetailChevron = ({ isOpen }) => {
  return <ChevronIcon direction={isOpen ? 'down' : 'right'} />
}

export const List = styled.div`
  display: flex;
  flex-direction: column;
`

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.25em 0;
  align-items: center;
  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.pearlGrey};
  }
  cursor: pointer;
`

export const SelectDetailBox = styled.div`
  position: relative;
  font-size: 12px;
  font-family: ${props => props.theme.fonts.Montserrat};

  @media(max-width: 540px) {
    display: flex;
    flex-direction: column;
  }
`

export const Button = styled.button`
  height: 48px;
  width: 104px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  background-color: ${props => props.theme.colors.lightBlue};
  color: white;
  cursor: pointer;

  &:disabled,
  &[disabled] {
    background-color: ${props => props.theme.colors.pearlGrey};
  }
`

export const SelectBox = styled.div`
  display: flex;
  align-content: center;
  margin-bottom: 35px;
  ${Button} {
    margin-left: 1em;
  }

  @media(max-width: 540px) {
    flex-direction: column;
    ${Button} {
      margin-left: 0;
    }
    & > * {
      margin-bottom: 10px;
      width: 100%;
    }
  }
`

export const Label = styled.span`
  color: ${props => props.theme.colors.blueGrey};
`

export const StyledSelectContainer = styled.div`
  flex: 1;
`

// Styles that should be provided to a react-select via the 'styles' prop
export const SelectStyles = {
  control: (provided) => ({
    ...provided,
    width: '100%',
    borderRadius: 0,
    height: 48
  })
}

const ListItemContentDefinition = styled.div`
  display: flex;
  flex: 1;
  flex-direction: ${props => (props.vertical && 'column') || 'row'};
  position: relative;
  word-wrap: break-word;
  flex-wrap: wrap;
  background-color: #fff;
  min-width: 375px;
`
ListItemContentDefinition.displayName = 'ListItemContent'
export const ListItemContent = ListItemContentDefinition
